import _objectSpread from "reshow-runtime/es/helpers/objectSpread2";
import _extends from "reshow-runtime/es/helpers/extends";
import _classCallCheck from "reshow-runtime/es/helpers/classCallCheck";
import _createClass from "reshow-runtime/es/helpers/createClass";
import _assertThisInitialized from "reshow-runtime/es/helpers/assertThisInitialized";
import _possibleConstructorReturn from "reshow-runtime/es/helpers/possibleConstructorReturn";
import _getPrototypeOf from "reshow-runtime/es/helpers/getPrototypeOf";
import _inherits from "reshow-runtime/es/helpers/inherits";
import _defineProperty from "reshow-runtime/es/helpers/defineProperty";

function _createSuper(Derived) { return function () { var Super = _getPrototypeOf(Derived), result; if (_isNativeReflectConstruct()) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

import React, { Component } from 'react';
import { SemanticUI, reactStyle } from 'react-atomic-molecule';
import CarouselList from '../organisms/CarouselList';
import CarouselSwipe from '../organisms/CarouselSwipe';

var CarouselSlide = /*#__PURE__*/function (_Component) {
  _inherits(CarouselSlide, _Component);

  var _super = _createSuper(CarouselSlide);

  function CarouselSlide(props) {
    var _this;

    _classCallCheck(this, CarouselSlide);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "handleHeight", function (height) {
      _this.setState({
        height: height
      });
    });

    _this.state = {
      height: 'auto'
    };
    return _this;
  }

  _createClass(CarouselSlide, [{
    key: "render",
    value: function render() {
      var others = _extends({}, this.props);

      return /*#__PURE__*/React.createElement(SemanticUI, {
        style: _objectSpread({}, Styles.container, {
          height: this.state.height
        })
      }, /*#__PURE__*/React.createElement(CarouselList, _extends({}, others, {
        innerContainer: /*#__PURE__*/React.createElement(CarouselSwipe, {
          onHeight: this.handleHeight
        })
      })));
    }
  }]);

  return CarouselSlide;
}(Component);

export default CarouselSlide;
var Styles = {
  container: {
    overflow: 'hidden'
  }
};